import axios from "axios";
import * as actions from "./actionCreators";
import DatacodeConfig from "../../../core/config";
import * as constants from "../constants";
import { scheduleTokenExpiryLogout } from "../../../utils";

const baseURL = DatacodeConfig.baseURL;

export const setTestUser = (user) => (dispatch) => {
  dispatch(actions.setLoginUser(user));
};

export const loginUser = (user) => async (dispatch) => {
  dispatch({ type: constants.GET_LOGIN_USER_LOADING });
  return axios
    .post(`${baseURL}/user/login`, user)
    .then((res) => {
      if (res.status === 200) {
        if (res.data.success) {
          dispatch({ type: constants.GET_LOGIN_USER_LOADING });
          const userData = {
            _id: res.data.data._id,
            firstName: res.data.data.firstName,
            lastName: res.data.data.lastName,
            imgUrl: res.data.data.imgUrl,
            token: res.data.token,
          };
          dispatch(actions.setLoginUser(userData));
          return { success: true, data: res.data };
        } else {
          dispatch({ type: constants.GET_LOGIN_USER_LOADING });
          return { success: false, data: res.data };
        }
      }
    })
    .catch((error) => {
      dispatch(actions.setLoginUserError(error));
      console.log("Login error", error);
    });
};

export const signupUser = (user) => async (dispatch) => {
  return axios
    .post(`${baseURL}/user/signup`, user)
    .then((res) => {
      if (res.status === 200) {
        dispatch(actions.setSignupUser(res.data));
        console.log("Signed you", res.data);
        return { success: true, data: res.data };
      }
    })
    .catch((error) => {
      dispatch(actions.setSignupUserError(error));
      console.log("Signup error", error);
    });
};

export const forgotPassword = (user) => async (dispatch) => {
  return axios
    .post(`${baseURL}/user/forgot-password`, user)
    .then((res) => {
      if (res.status === 200) {
        console.log("Forgot Password", res.data);
        return { success: true, data: res.data };
      }
    })
    .catch((error) => {
      console.log("Forgot Password error", error);
    });
};

export const checkAuth =
  (token, setIsAuthenticated, handleAutoLogout) => async (dispatch) => {
    return axios
      .post(
        `${baseURL}/user/validate-token`,
        { token },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.status === 200) {
          scheduleTokenExpiryLogout(token, handleAutoLogout);
          setIsAuthenticated(true);
          return { success: true, data: response?.data?.user };
        }
      })
      .catch((error) => {
        console.error("Authentication error:", {
          message: error?.message || "Unknown error occurred",
          status: error?.response?.status,
          data: error?.response?.data,
          stack: error?.stack,
        });
        scheduleTokenExpiryLogout(token, handleAutoLogout);
        setIsAuthenticated(false);
        return {
          success: false,
          error: error?.response?.data || "Request failed",
        };
      });
  };

export const authCheck = (authProfile) => (dispatch) => {
  dispatch({ type: constants.SET_LOGIN_USER_LOADING });
  return axios
    .post(`${baseURL}/user/authCheck`, authProfile)
    .then((res) => {
      if (res.data && res.data.success === true) {
        dispatch({ type: constants.SET_LOGIN_USER_LOADING });
        const userData = {
          _id: res.data.data._id,
          firstName: res.data.data.firstName,
          lastName: res.data.data.lastName,
          imgUrl: res.data.data.imgUrl,
          token: res.data.token,
        };
        dispatch(actions.setLoginUser(userData));
        return { success: true, data: res?.data?.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      dispatch({ type: constants.SET_LOGIN_USER_LOADING });
      console.log("Auth Check Error", error);
    });
};